<template>
    <v-layout row wrap>
    <v-stepper v-model="e1" style="width: 100%">
        <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Nueva Actuación</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">Validar Actuación Profesional</v-stepper-step>

<!--             <v-divider></v-divider>

            <v-stepper-step step="3">Cargar Pago</v-stepper-step> -->
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
                <FormNuevaActuacion :params="paramsHome" :loading="loading" v-on:loadingResponse="loading = $event" v-on:nuevaActuacionResponse="nuevaActuacionResponse($event)" />
            </v-stepper-content>

            <v-stepper-content step="2">
                <FormValidarActuacion v-if="e1 == 2" :requirements="documentsRequirementsSat" :devolutions="devolutions_list" v-on:loadingResponse="loading = $event" v-on:validarActuacion="validarActuacion($event)" />
            </v-stepper-content>

            <!-- <v-stepper-content step="3">
                <FormCargarPago :loading="loading" :rap="dataRap" v-on:loadingResponse="loading = $event" v-on:receivedPay="receivedPay($event)" />
            </v-stepper-content> -->
        </v-stepper-items>

    </v-stepper>

        <v-dialog v-model="loading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Porfavor Espere...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import Form from 'vform'
import axios from 'axios'
import { mapGetters } from 'vuex'
import FormNuevaActuacion from '~/pages/cliente/FormNuevaActuacion.vue'
import FormValidarActuacion from '~/pages/cliente/FormValidarActuacion.vue'
// import FormCargarPago from '~/pages/cliente/FormCargarPago.vue'

export default {

    name: "view-nueva-actuacion",
    
    components: {
        FormNuevaActuacion,
        FormValidarActuacion
        // FormCargarPago
    },

    computed: {
        ...mapGetters({
            documentsRequirementsSat: 'getDocumentRequirementSat',
            devolutions_list: 'getSatDevolutionsList'
        })
    },

    data () {
        return {
            e1: 0,
            dataRap: {},
            dialog: false,
            loading: false,
            paramsHome: {},
        }
    },

    mounted () {
        if (this.$route.params.item != undefined) {
            this.paramsHome = this.$route.params.item
        }
    },

    methods: {

        async nuevaActuacionResponse(datos) {
            this.e1 = 2
            await this.$store.dispatch('searchDocumentRuapRequirement', datos.data[0].id)
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async validarActuacion(datos) {
            this.dataRap = {}
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async receivedPay(datos) {
            this.e1 = 0
            this.dataRap = {}
            this.$nextTick(() => {
                this.loading = false
            })
        }
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/NuevaActuacion.vue